import { gsap,ScrollTrigger,ScrollToPlugin,Back,Elastic,Circ,Expo,Sine,Linear} from 'gsap/all';
/*================================

ContentsList

================================*/
export class ContentsList {
    constructor(pamph) {
        this.pamph = pamph;
        //目次リスト
        this.list = [
            {
                page: 0, dir:'right', small:false, title: 'Front Cover'
            },
            {
                page: 1, dir:'right', small:false, title: 'Contents'
            },
            {
                page: 2, dir:'left', small:false,  title: 'Top Message'
            },
            {
                page: 3, dir:'left', small:false, title: 'Sustainability Management/<br>Decarbonization Initiatives'
            },
            {
                page: 3, dir:'right', small:false, title: 'Diversity & Inclusion/<br>Biodiversity Initiatives'
            },
            {
                page: 4, dir:'left', small:false, title: 'Mitsui Fudosan&#39;s Neighborhood Creation'
            },
            {
                page: 5, dir:'left', small:true, title: 'Nihonbashi Revitalization Plan'
            },
            {
                page: 6, dir:'left', small:true, title: 'Kashiwa-no-ha Smart City'
            },
            {
                page: 7, dir:'left', small:true, title: 'Large-scale Projects in Tokyo'
            },
            {
                page: 8, dir:'left', small:true, title: 'Global Initiatives'
            },
            {
                page: 9, dir:'left', small:false, title: 'Business Fields'
            },
            {
                page: 10, dir:'left', small:true, title: 'Office Buildings'
            },
            {
                page: 11, dir:'left', small:true, title: 'Retail Properties'
            },
            {
                page: 12, dir:'right', small:true, title: 'Logistics Properties'
            },
            {
                page: 13, dir:'left', small:true, title: 'Hotels and Resorts'
            },
            {
                page: 14, dir:'left', small:true, title: 'Homes and Lifestyle'
            },
            {
                page: 15, dir:'left', small:true, title: 'Solution Partner'
            },
            {
                page: 15, dir:'right', small:true, title: 'Moving Into New Fields of Business'
            },
            {
                page: 16, dir:'left', small:true, title: 'New Business Development Initiatives'
            },
            {
                page: 16, dir:'right', small:true, title: 'DX (Digital Transformation) Initiatives'
            },
            {
                page: 16, dir:'right', small:true, title: 'Space & Environment Institute'
            },
            {
                page: 16, dir:'right', small:true, title: 'CARE DESIGN Department'
            },
            {
                page: 17, dir:'left', small:false, title: 'Corporate Data/Executive Officers/Domestic Network'
            },
            {
                page: 17, dir:'right', small:false, title: 'Organization Chart'
            },
            {
                page: 18, dir:'left', small:false, title: 'Major Group Companies'
            },
            {
                page: 18, dir:'right', small:false, title: 'Financial Highlights'
            },
            {
                page: 19, dir:'left', small:false, title: 'History'
            },
        ];
        this.contents = document.querySelector('.js-contents');
        this.contentsInner = document.querySelector('.js-contents-inner');
        this.contentsList = document.querySelector('.js-contents-list');
        this.contentsBG = document.querySelector('.js-contents-bg');
        this.btnClose = document.querySelector('.js-contents-close');
        this.close = this.close.bind(this);


        this.init();
    }

    //初期設定
    init() {
        for(let i=0;i < this.list.length;i++) {
            const o = this.list[i];
            const li = document.createElement('li');
            const button = document.createElement('button');
            li.classList.add('contents__list');
            if(o.small) li.classList.add('contents__list--small');
            button.innerHTML = o.title;
            button.dataset.target = o.page;
            button.dataset.page = o.dir;

            li.appendChild(button);


            this.contentsList.appendChild(li);

            button.addEventListener('click',() => {
                this.pamph.pageDir = button.dataset.page;
                this.pamph.pageJump(Number(button.dataset.target),this.pamph.pageDir);
                if(window.innerWidth <= 768) this.close();

            });
        }
        if(window.innerWidth > 768) {
            this.contents.style.display = 'block';
            gsap.set('.wrapper',{width: 'calc(100% - 300px)'});
            gsap.set(this.contentsBG,{opacity:1});
            gsap.set(this.contentsInner,{x:'0%'});
            gsap.set('.control',{right: 320});
            this.btnClose.addEventListener('click',this.close);
            this.contentsBG.addEventListener('click',this.close);
        }
    }

    open() {
        this.contents.style.display = 'block';
        gsap.fromTo(this.contentsBG,{
            opacity: 0
        },{
            opacity: 1,
            duration: 0.3
        });
        gsap.fromTo(this.contentsInner,{
            x: '100%'
        },{
            x: '0%',
            duration: 0.3
        });
        gsap.to('.wrapper',{
            width: 'calc(100% - 300px)',
            duration: .3
        });
        gsap.to('.control',{
            right: 320,
            duration: 0.3
        })

        this.btnClose.addEventListener('click',this.close);
        this.contentsBG.addEventListener('click',this.close);

    }

    close() {
        this.btnClose.removeEventListener('click',this.close);
        this.contentsBG.removeEventListener('click',this.close);
        gsap.to(this.contentsBG,{
            opacity:0,
            duration: 0.3
        });
        gsap.to(this.contentsInner,{
            x: '100%',
            duration: 0.3,
            onComplete: () => {
                this.contents.style.display = 'none';
            }
        });
        gsap.to('.wrapper',{
            width: '100%',
            duration: .3
        })
        gsap.to('.control',{
            right: 20,
            duration: 0.3
        })

    }
}